module.exports = __webpack_public_path__ + "img/equip.3d64f0e7.png";